import {LANGUAGE} from "@/common/utils/constants.js";

export const GOP_OFFERS = {
	[LANGUAGE.en.short]: {
		loading: "Loading...",
		offers: "Offers",
		offer: "Offer",
		offersMatch: "Offers match your search",
		globalOffersAvailable: "Global offers available",
		potentialOffersMatch: "Other potential offers match your search",
		searchPlaceholder: "Search for Id, Title etc",
		filter: "Filter",
		industry: "Industry",
		serviceLines: "Type of Business",
		techPractices: "Tech Practices",
		toolsAndSystems: "Tools & Systems",
		certificates: "Certifications",
		mainClientPersonas: "Main Client Personas",
		lifecycles: "Lifecycles",
		globalOwners: "Owners",
		years: 'Years',
		clear: "Clear",
		search: "Search...",
		removeAll: "Remove All",
		savedOffers: "Saved Offers",
		mySavedOffers: "My saved offers",
		and: "and",
		more: "more...",
		selectedFilters: "selected filters",
		"DESC": 'Latest',
		"ASC": 'Oldest',
		grid: "Grid",
		list: "List",
		statuses: {
			draft: 'Draft',
			published: 'Published',
			archived: 'Archived'
		},
		managementButtons: {
			edit: 'Edit',
			delete: 'Delete',
			archive: 'Archive',
			unarchive: 'Unarchive',
			translate: 'Translate'
		},
		deliveryLocations: "Delivery Locations",
		downloadExcelReport :"Download Report (.xlsx)",
		reportTimeFrame: "Report Time Frame",
		corporatePresentation: "Corporate Presentation",
		partnershipPresentation: "Partnership Presentation",
		techPracticePresentation: "Tech Practice Presentation",
		areYouSureDelete: `Are you sure you want to delete this {item}?`,
		cannotBeRestored: `Once the {item} is deleted, it cannot be restored.`,
		region: "Region",
		analysts: "Analysts",
		certifications: "Certifications",
		clientEnvironment: "Main Client Persona",
		owners: "Owners",
	},
	[LANGUAGE.de.short]: {
		loading: "Wird geladen …",
		offers: "Angebote",
		offer: "Angebot",
		offersMatch: "Passende Angebote zu Ihrer Suche",
		globalOffersAvailable: "Global verfügbare Angebote",
		potentialOffersMatch: "Weitere passende Angebote zu Ihrer Suche",
		searchPlaceholder: "Geben Sie einen Suchbegriff ein und drücken Sie die Eingabetaste.",
		filter: "Filter",
		industry: "Industry",
		serviceLines: "Geschäftsart",
		techPractices: "Technologiepraktiken",
		toolsAndSystems: "Tools & Systeme",
		certificates: "Zertifizierungen",
		mainClientPersonas: "Haupt-Client Persona",
		lifecycles: "Lebenszyklen",
		globalOwners: "Eigentümer",
		years: 'Jahre',
		clear: "Löschen",
		search: "Suche",
		removeAll: "Alles entfernen",
		savedOffers: "Gespeicherte Angebote",
		mySavedOffers: "Meine gespeicherten Angebote",
		and: "Und",
		more: "mehr...",
		selectedFilters: "ausgewählte Filter",
		"DESC": 'Neueste',
		"ASC": 'Älteste',
		grid: "Netz",
		list: "Aufführen",
		statuses: {
			draft: 'Entwurf',
			published: 'Veröffentlicht',
			archived: 'Archivieren'
		},
		managementButtons: {
			edit: 'Bearbeiten',
			delete: 'Löschen',
			archive: 'Archivieren',
			unarchive: 'Archivierung aufheben',
			translate: 'Übersetzen'
		},
		deliveryLocations: "Delivery-Standorte",
		downloadExcelReport :"Bericht herunterladen (.xlsx)",
		reportTimeFrame: "Berichtszeitraum",
		corporatePresentation: "Unternehmenspräsentation",
		partnershipPresentation: "Partnerschaftspräsentation",
		techPracticePresentation: "Tech Practice Präsentation",
		areYouSureDelete: `Möchten Sie dieses {item} wirklich löschen?`,
		cannotBeRestored: `Sobald das {item} gelöscht wurde, kann es nicht wiederhergestellt werden`,
		region: "Region",
		analysts: "Angebote",
		certifications: "Zertifizierungen",
		clientEnvironment: "Haupt-Client Persona",
		owners: "Eigentümer",
	},
	[LANGUAGE.fr.short]: {
		loading: "Chargement...",
		offers: "Offres",
		offer: "Offre",
		offersMatch: "Offres correspondant à votre recherche",
		globalOffersAvailable: "Offres disponibles",
		potentialOffersMatch: "Autres offres potentielles",
		searchPlaceholder: "Commencez à taper et appuyez sur Entrée pour voir toutes les offres",
		filter: "Filtre",
		industry: "Industries",
		serviceLines: "Type d'activité",
		techPractices: "Practices technologiques",
		toolsAndSystems: "Outils et systèmes",
		certificates: "Certifications",
		mainClientPersonas: "Profil client",
		lifecycles: "Cycles de vie",
		globalOwners: "Propriétaires",
		years: 'Années',
		clear: "Effacer",
		search: "Chercher...",
		removeAll: "Supprimer tout",
		savedOffers: "Offres enregistrées",
		mySavedOffers: "Mes offres enregistrées",
		and: "et",
		more: "plus de",
		selectedFilters: "filtres sélectionnés",
		"DESC": 'Le dernier',
		"ASC": 'Le plus ancien',
		grid: "Grille",
		list: "Liste",
		statuses: {
			draft: 'Brouillon',
			published: 'Publié',
			archived: 'Archivé'
		},
		managementButtons: {
			edit: 'Éditer',
			delete: 'Supprimer',
			archive: 'Archiver',
			unarchive: 'Non archivable',
			translate: 'Traduire'
		},
		deliveryLocations: "Lieux de livraison",
		downloadExcelReport :"Télécharger le rapport (.xlsx)",
		reportTimeFrame: "Période du rapport",
		corporatePresentation: "Présentation de l'entreprise",
		partnershipPresentation: "Présentation du partenariat",
		techPracticePresentation: "Présentation de la pratique technologique",
		areYouSureDelete: `Êtes-vous sûr de vouloir effectuer cette suppression ?`,
		cannotBeRestored: `Une fois l'élément supprimé, il ne pourra être restauré.`,
		region: "Région",
		analysts: "Analysts",
		certifications: "Certifications",
		clientEnvironment: "Profil client",
		owners: "Propriétaires",
	},
	[LANGUAGE.it.short]: {
		loading: "Caricamento...",
		offers: "Offerte",
		offer: "Offerta",
		offersMatch: "Le offerte corrispondono alla tua ricerca",
		globalOffersAvailable: "Tutte le Soluzioni Globali disponibili",
		potentialOffersMatch: "altri potenziali offerte corrispondono alla tua ricerca",
		searchPlaceholder: "Cerca per Id, Titolo ecc",
		filter: "Filtro",
		industry: "Industria",
		serviceLines: "Tipologia di attività",
		techPractices: "Pratiche tecniche",
		toolsAndSystems: "Strumenti e sistemi",
		certificates: "Certificazioni",
		mainClientPersonas: "Personaggi principali del cliente",
		lifecycles: "Cicli di vita",
		globalOwners: "Proprietari",
		years: 'Anni',
		clear: "Cancella",
		search: "Ricerca...",
		removeAll: "Rimuovi tutto",
		savedOffers: "Offerte salvate",
		mySavedOffers: "Le mie offerte salvate",
		and: "E",
		more: "di più...",
		selectedFilters: "filtri selezionati",
		"DESC": 'Ultimo',
		"ASC": 'Il più antico',
		grid: "Griglia",
		list: "Elenco",
		statuses: {
			draft: 'Bozza',
			published: 'Pubblicato',
			archived: 'Archiviato'
		},
		managementButtons: {
			edit: 'Modificare',
			delete: 'Eliminare',
			archive: 'Archivio',
			unarchive: 'Annulla l\'archiviazione',
			translate: 'Tradurre'
		},
		deliveryLocations: "Luoghi di consegna",
		downloadExcelReport :"Scarica il report (.xlsx)",
		reportTimeFrame: "Periodo del report",
		corporatePresentation: "Presentazione aziendale",
		partnershipPresentation: "Presentazione della partnership",
		techPracticePresentation: "Presentazione della pratica tecnologica",
		areYouSureDelete: `Sei sicuro di voler eliminare questo {item}?`,
		cannotBeRestored: `Una volta eliminato, l'elemento {item} non potrà più essere ripristinato.`,
		region: "Regione",
		analysts: "Analysts",
		certifications: "Certificazioni",
		clientEnvironment: "Profilo principale del cliente",
		owners: "Proprietari",
	},
	[LANGUAGE.ja.short]: {
		loading: "読み込み中...",
		offers: "オファー",
		offer: "オファー",
		offersMatch: "検索に一致するオファー",
		globalOffersAvailable: "利用可能なグローバルオファー",
		potentialOffersMatch: "その他の潜在的なオファーが検索に一致",
		searchPlaceholder: "ID、タイトルなどで検索",
		filter: "フィルタ",
		industry: "業界",
		serviceLines: "事業の種類",
		techPractices: "技術プラクティス",
		toolsAndSystems: "ツールとシステム",
		certificates: "認証",
		mainClientPersonas: "主要なクライアントパーソナ",
		lifecycles: "ライフサイクル",
		globalOwners: "オーナー",
		years: '年',
		clear: "クリア",
		search: "検索...",
		removeAll: "すべて削除する",
		savedOffers: "保存されたオファー",
		mySavedOffers: "私の保存されたオファー",
		and: "そして",
		more: "もっと...",
		selectedFilters: "選択したフィルター",
		"DESC": '最新',
		"ASC": '最古の',
		grid: "グリッド",
		list: "リスト",
		statuses: {
			draft: '下書き',
			published: '発行済み',
			archived: 'アーカイブ済み'
		},
		managementButtons: {
			edit: '編集',
			delete: '消去',
			archive: 'アーカイブ',
			unarchive: 'アーカイブを解除する',
			translate: '翻訳'
		},
		deliveryLocations: "配信場所",
		downloadExcelReport :"レポートをダウンロードする (.xlsx)",
		reportTimeFrame: "レポートの期間",
		corporatePresentation: "企業プレゼンテーション",
		partnershipPresentation: "パートナーシッププレゼンテーション",
		techPracticePresentation: "テクニカルプラクティスプレゼンテーション",
		areYouSureDelete: `この{item}を削除してもよろしいですか?`,
		cannotBeRestored: `{item} を削除すると、復元することはできません。`,
		region: "地域",
		analysts: "アナリスト",
		certifications: "認証",
		clientEnvironment: "主要なクライアントパーソナ",
		owners: "オーナー",
	},
	[LANGUAGE.es.short]: {
		loading: "Cargando...",
		offers: "Ofertas",
		offer: "Oferta",
		offersMatch: "Ofertas que coinciden con tu búsqueda",
		globalOffersAvailable: "Ofertas globales disponibles",
		potentialOffersMatch: "Otras ofertas que coinciden potencialmente con tu búsqueda",
		searchPlaceholder: "Buscar por ID, Título, etc.",
		filter: "Filtrar",
		industry: "Industria",
		serviceLines: "Tipo de negocio",
		techPractices: "Prácticas tecnológicas",
		toolsAndSystems: "Herramientas y sistemas",
		certificates: "Certificaciones",
		mainClientPersonas: "Personas principales del cliente",
		lifecycles: "Ciclos de vida",
		globalOwners: "Propietarios",
		years: 'Años',
		clear: "Borrar",
		search: "Buscar...",
		removeAll: "Eliminar todo",
		savedOffers: "Ofertas guardadas",
		mySavedOffers: "Mis ofertas guardadas",
		and: "y",
		more: "más...",
		selectedFilters: "filtros seleccionados",
		"DESC": 'Más reciente',
		"ASC": 'Más antiguo',
		grid: "Cuadrícula",
		list: "Lista",
		statuses: {
			draft: 'Borrador',
			published: 'Publicado',
			archived: 'Archivado'
		},
		managementButtons: {
			edit: 'Editar',
			delete: 'Eliminar',
			archive: 'Archivar',
			unarchive: 'Desarchivar',
			translate: 'Traducir'
		},
		deliveryLocations: "Ubicaciones de entrega del proyecto",
		downloadExcelReport :"Descargar informe (.xlsx)",
		reportTimeFrame: "Período del informe",
		corporatePresentation: "Presentación corporativa",
		partnershipPresentation: "Presentación de la asociación",
		techPracticePresentation: "Presentación de prácticas tecnológicas",
		areYouSureDelete: `¿Estás seguro de que deseas eliminar este {elemento}?`,
		cannotBeRestored: `Una vez eliminado el {elemento}, no se puede recuperar.`,
		region: "Región",
		analysts: "Analistas",
		certifications: "Certificaciones",
		clientEnvironment: "Perfil principal del cliente",
		owners: "Propietarios",
	}
}
